const kohlerUSSmartCropImageSize = {
  1: {
    portrait: {
      general: {
        1023: "340px",
        768: "calc(calc(100vw - 100px * 2) * 0.4755)",
        220: "calc(100vw - 3.0625rem * 2)"
      },
      business: {
        1023: "340px",
        768: "calc(calc(100vw - 100px * 2) * 0.4755)",
        220: "calc(100vw - 3.0625rem * 2)"
      }
    },
    landscape: {
      general: {
        1023: "340px",
        768: "calc(calc(100vw - 100px * 2) * 0.4755)",
        220: "calc(100vw - 3.0625rem * 2)"
      },
      business: {
        1023: "340px",
        768: "calc(calc(100vw - 100px * 2) * 0.4755)",
        220: "calc(100vw - 3.0625rem * 2)"
      }
    }
  },
  2: {
    portrait: {
      general: {
        1600: "340px",
        1440: "305px",
        1023: "250px",
        768: "calc(calc(100vw - 100px * 2) * 0.4755)",
        220: "calc(100vw - 3.0625rem * 2)"
      },
      business: {
        1600: "340px",
        1440: "280px",
        1023: "240px",
        768: "calc(calc(100vw - 100px * 2) * 0.4755)",
        220: "calc(100vw - 3.0625rem * 2)"
      }
    },
    landscape: {
      business: {
        1920: "440px",
        1600: "415px",
        1440: "335px",
        1023: "303px",
        768: "calc(calc(100vw - 100px * 2) * 0.4755)",
        220: "calc(100vw - 3.0625rem * 2)"
      }
    }
  }
};
function getSmartCropWidth({
  screenWidth,
  imagesLength,
  isSmartCrop,
  imageOrientation,
  isBusinessTab
}) {
  if (!isSmartCrop) return void 0;
  const layoutTier = imagesLength;
  const context = isBusinessTab ? "business" : "general";
  const orientation = imageOrientation === "portrait" ? "portrait" : "landscape";
  const breakpoints = kohlerUSSmartCropImageSize[layoutTier]?.[orientation]?.[context];
  if (!breakpoints) return void 0;
  const sortedKeys = Object.keys(breakpoints).map(Number).sort((a, b) => a - b);
  let selected;
  for (const bp of sortedKeys) {
    if (screenWidth >= bp) {
      selected = breakpoints[bp];
    } else {
      break;
    }
  }
  return selected;
}

export { getSmartCropWidth, kohlerUSSmartCropImageSize };
